export const MachineLearningSolutionPageContent = {
    ecommerce: {
        meta: {
            title: 'AI & Machine Learning solutions for Ecommerce',
            description:
                'Grow your Ecommerce business through targeted product recommendations, offers, identifying upsell opportunities, and more with AI & ML solutions for Ecommerce.',
            ogURL: '/machine-learning-solutions/ecommerce',
            ogImage: `${process.env.NEXT_PUBLIC_APP_URL}/og-images/og-images_ecommerce.jpg`,
        },
        banner: {
            title: 'Create a Personalized and Targeted Ecommerce Experience With',
            description:
                'Use state-of-the-art AI & Machine Learning Ecommerce tools to boost your sales by identifying upsell opportunities, recommending products, special offers, and more.',
            videoUrl: '/video/ecommerce.mp4',
            coverImage: '/video/cover/ecommerce.png',
        },
        section: {
            heading:
                'Convert visitors to loyal returning customers with strategies that leverage AI & Machine Learning',
            description:
                'Leverage machine learning to make product discovery easier for your visitors by placing the right recommendations at every step of the user journey. Smart Answers offers an easy-to-use approach towards understanding the data you gather from your Ecommerce site, and identifying opportunities for growth.',
        },
        cardData: [
            {
                id: 1,
                title: 'Product Recommendations',
                description:
                    'Tailored product recommendations unique to each individual customer based on their profile and shopping habits.',
                img: '/horizontal-content-card/product-recommendation.svg',
            },
            {
                id: 2,
                title: 'Upsell and Cross-sell',
                description:
                    'Identify opportunites for increasing the value of the sale through AI recommendations on bundling and offering sales on related items.',
                img: '/horizontal-content-card/upsell-and-cross.svg',
            },
            {
                id: 3,
                title: 'Similar Products',
                description:
                    'Recommend similar products based on attributes you deem most important. Recommendation engines increase sales by up to 35% or more.',
                img: '/horizontal-content-card/similar-products.svg',
            },
            {
                id: 4,
                title: 'Buying Together',
                description:
                    'Based on shopper patterns and behaviors, the Smart Answers platform can identify items that are usually bought together to inform business strategies and UI choices.',
                img: '/horizontal-content-card/buying-together.svg',
            },
            {
                id: 5,
                title: 'Trending Products',
                description:
                    'Identify products that may be trending for various reasons other than just sales. These may include increase in traffic, shares, and many more attributes.',
                img: '/horizontal-content-card/trending-products.svg',
            },
            {
                id: 6,
                title: 'Customer Feedback Sentiment Analysis',
                description:
                    'Go beyond just the number of stars a review has given a product. Find deeper insight based on the tone and sentiment of the shopper in their review.',
                img: '/horizontal-content-card/customer-feedback-sentiment-analysis.svg',
            },
        ],
    },

    'social-media-communication': {
        meta: {
            title: 'Social Media Communication powered by AI',
            description:
                'Improve your social media and communication activities by leveraging AI & Machine Learning to identify a shift in public perception over time.',
            ogURL: '/machine-learning-solutions/social-media-communication',
            ogImage: `${process.env.NEXT_PUBLIC_APP_URL}/og-images/og-images_social-media-communication.jpg`,
        },
        banner: {
            title: 'Social Media Content & Communication Analysis Using',
            description:
                'Improve your social media and communication activities by leveraging AI & Machine Learning to identify a shift in public perception over time. Monitor trends and adapt.',
            videoUrl: '/video/socialmedia-communication.mp4',
            coverImage: '/video/cover/social-media-communication.png',
        },
        section: {
            heading:
                'Supercharge Your Content Writing, Marketing & Communication with the power of AI & Machine Learning',
            description:
                "Whether it's social media, news articles, press releases or more, Smart Answers can monitor and analyse the sentiment behind online content and provide you with insights over time so you can adapt and course correct as needed.",
        },
        cardData: [
            {
                id: 1,
                title: 'Sentiment Analysis',
                description:
                    'Go beyond just how much engagement you are getting and read into the sentiment of the posts. Sentiment Analysis will tell you the public perception over time.',
                img: '/horizontal-content-card/advanced-sentiment-analysis.svg',
            },
            {
                id: 2,
                title: 'Content Analysis & Entity Extraction',
                description:
                    'Analyze articles, documents, press releases and more, to find mentions of specific entities and their overall sentiment.',
                img: '/horizontal-content-card/content-analysis.svg',
            },
            {
                id: 3,
                title: 'Content Summarization',
                description:
                    'Generate executive summaries, synopsis and other briefings from long documents and articles to get the gist of the content without the tedious and time-consuming manual work.',
                img: '/horizontal-content-card/content-summarization.svg',
            },
            {
                id: 4,
                title: 'Keyword Extraction',
                description:
                    'Find articles and posts from defined sources that contain a given keyword and understand the context behind it to make sure nothing slips through the cracks.',
                img: '/horizontal-content-card/keyword-extraction.svg',
            },
        ],
    },

    'digital-marketing': {
        meta: {
            title: 'Optimize Digital Marketing campaigns with AI',
            description:
                'Optimize your digital marketing campaigns with AI powered insight on why different campaigns are over or under performing so you can course-correct or double-down.',
            ogURL: '/machine-learning-solutions/digital-marketing',
            ogImage: `${process.env.NEXT_PUBLIC_APP_URL}/og-images/og-images_digital-marketing.jpg`,
        },
        banner: {
            title: 'Improve Your Marketing Campaigns & Conversion Rates Using',
            description:
                'Optimize your digital marketing campaigns with AI powered insight on why different campaigns are over or under performing so you can course-correct or double-down.',
            videoUrl: '/video/digital-marketing.mp4',
            coverImage: '/video/cover/digital-marketing.png',
        },
        section: {
            heading:
                'Gain deep insights on the performance of digital marketing campaigns with suggestions on how to improve them',
            description:
                'Machine learning and AI takes historical data of digital marketing campaigns to analyze and identify patterns and prior results to inform current and future campaigns. This helps identify campaigns that may under-perform before you end up spending too much money on them.',
        },
        cardData: [
            {
                id: 1,
                title: 'Customer Segmentation',
                description:
                    'Let AI comb through mountains of data to find similar customers based on their attributes and provide suggestions on how to best approach them.',
                img: '/horizontal-content-card/customer-segmentation.svg',
            },
            {
                id: 2,
                title: 'Marketing Campaigns Analysis',
                description:
                    'Analyze and iterate on digital marketing campaigns with AI powered analysis to help you identify low hanging fruit. Double-down and course-correct as needed.',
                img: '/horizontal-content-card/marketing-campaigns-analysis.svg',
            },
            {
                id: 3,
                title: 'Lead Scoring',
                description:
                    'Determine the quality of inbound leads based on custom attributes that you deem important with weightage based on prior experience and datasets. Prioritize the right customers.',
                img: '/horizontal-content-card/lead-scoring.svg',
            },
            {
                id: 4,
                title: 'Conversational Sentiment Analysis',
                description:
                    'Go beyond just views and clicks to analyze the sentiment behind user engagement on social media ads.',
                img: '/horizontal-content-card/conversational-sentiment-analysis.svg',
            },
        ],
    },

    enterprise: {
        meta: {
            title: 'AI & ML solutions to transform the Enterprise',
            description:
                'Leverage Machine Learning & AI to transform the Enterprise from Sales to Finance to HR and more. Gain hidden insight, optimize business processes and much more.',
            ogURL: '/machine-learning-solutions/enterprise',
            ogImage: `${process.env.NEXT_PUBLIC_APP_URL}/og-images/og-images_enterprise.jpg`,
        },
        banner: {
            title: 'Transform the Enterprise with the power of AI & Machine Learning using',
            description:
                'Embrace data-driven decision making by leveraging AI & Machine Learning to generate actionable business insights.',
            videoUrl: '/video/enterprise.mp4',
            coverImage: '/video/cover/enterprise.png',
        },
        section: {
            heading:
                'Use Machine Learning & AI to Identify Trends, Patterns and Insights to Drive Business Decisions',
            description:
                'Business process re-engineering, data-driven decision making, and predictive analytics are all just a few of the ways you can leverage AI & Machine Learning to transform the Enterprise.',
        },
        cardData: [
            {
                id: 1,
                title: 'Lead Scoring',
                description:
                    'Identify certain attributes as important to your business and use them to score inbound leads. Learn from past lead conversions. Prioritize the right leads.',
                img: '/horizontal-content-card/lead-scoring.svg',
            },
            {
                id: 2,
                title: 'Job Candidate Matching',
                description:
                    'A matching engine that HR companies use to match candidates to jobs. Identify the right candidates for the job and learn from past job applications.',
                img: '/horizontal-content-card/job-candidate-matching.svg',
            },
            {
                id: 3,
                title: 'Customer Churn Prediction',
                description:
                    'Based on training data of previous contracts that either renewed or churned, the ML model is able to predict when a current customer will churn.',
                img: '/horizontal-content-card/customer-churn-prediction.svg',
            },
            {
                id: 4,
                title: 'Forecasting',
                description:
                    'A forecasting engine that projects sales, revenue, profit, etc. based on historical data and current trends. Customize the KPIs to your business.',
                img: '/horizontal-content-card/forecastings.svg',
            },
        ],
    },

    'real-estate': {
        meta: {
            title: 'AI & Machine Learning Models for Real Estate',
            description:
                'Use AI & Machine Learning to evaluate the price of properties in relation to similar offerings on the market and predict shifting trends before they happen.',
            ogURL: '/machine-learning-solutions/real-estate',
            ogImage: `${process.env.NEXT_PUBLIC_APP_URL}/og-images/og-images_real-estate.jpg`,
        },
        banner: {
            title: 'Evaluate and Predict Real Estate Market Prices & Trends using',
            description:
                'Use Machine Learning & AI tools to gain insight on shifting market trends, predict the price of properties in relation to similar offerings on the market.',
            videoUrl: '/video/realestate.mp4',
            coverImage: '/video/cover/real-estate.png',
        },
        section: {
            heading:
                'Machine Learning Models That Can Predict Real Estate Market Trends Based on Historical Data And Current Trends',
            description:
                'Use Machine Learning & AI tools to gain insight on shifting market trends, predict the price of properties in relation to similar offerings on the market, and much more. Overlay your data with historical data to get the best results.',
        },
        cardData: [
            {
                id: 1,
                title: 'Property Recommendation',
                description:
                    'Based on a multitude of attributes, the ML model is able to recommend properties that are similar to the one you are looking for based on metrics you deem important.',
                img: '/horizontal-content-card/property-recommendation.svg',
            },
            {
                id: 2,
                title: 'Predict Property Market Value',
                description:
                    'Taking into account the market value of similar properties, the ML model is able to predict the market value of a property based on historical data and current trends.',
                img: '/horizontal-content-card/predict-roperty-market-value.svg',
            },
            {
                id: 3,
                title: 'Rent Predictor',
                description:
                    'Given historical data and the market trends, the ML model is able to predict the change in rent over time in the near future.',
                img: '/horizontal-content-card/rent-predictor.svg',
            },
            {
                id: 4,
                title: 'Identify Investment Opportunties',
                description:
                    'Look for diamongs in the rough using Machine Learning to identify properties that are worth investing in.',
                img: '/horizontal-content-card/identify-investment-opportunties.svg',
            },
        ],
    },

    restaurant: {
        meta: {
            title: 'Grow your Restaurant business by leveraging AI',
            description:
                'Gain invaluable insights into your restaurant operations such as which customers, items, time of day, and employees are generating the most value.',
            ogURL: '/machine-learning-solutions/restaurant',
            ogImage: `${process.env.NEXT_PUBLIC_APP_URL}/og-images/og-images_restaurant.jpg`,
        },
        banner: {
            title: 'Use Machine Learning To Take Restaurant Analytics To The Next Level With',
            description:
                'Leverage all the tools at your disposal to increase your restaurant revenue and improve efficiencies with Inventory Forecasting, Customer Happiness Rating, and more.',
            videoUrl: '/video/resturant.mp4',
            coverImage: '/video/cover/restaurant.png',
        },
        section: {
            heading:
                'Take Control Of Your Restaurant Operations Like Never Before With Machine Learning & AI.',
            description:
                'Find your best dishes, most productive staff members, rush hour timings, forecast inventory and cut down on waste by using tools at your disposal thanks to Machine Learning.',
        },
        cardData: [
            {
                id: 1,
                title: 'Inventory Forecast',
                description:
                    'Use the inventory forecasting feature to better predict the ingredients that will be needed on any given day and to reduce waste.',
                img: '/horizontal-content-card/inventory-forecast.svg',
            },
            {
                id: 2,
                title: 'Offers Recommendation',
                description:
                    'Based on historic data, the ML model is able to determine which time of day has the least demand and recommend the best offers to maximize revenue.',
                img: '/horizontal-content-card/offers-recommendation.svg',
            },
            {
                id: 3,
                title: 'Retarget Customers',
                description:
                    'Target your marketing efforts to the right customers based on their preferences and past experiences. Get people back into the restaurant with special offers and discounts.',
                img: '/horizontal-content-card/retarget-customers.svg',
            },
            {
                id: 4,
                title: 'Restaurant Analytics',
                description:
                    'Get a comprehensive dashboard on the best performing dishes, feedback, staff performance and much more, all in one place.',
                img: '/horizontal-content-card/restaurant-analytics.svg',
            },
        ],
    },
}

export const FeaturesCardContent = {
    heading:
        'Reasons why analysts, developers, and business executives all love Smart Answers',
    description:
        'Smart Answers was designed with ease of use at the forefront. Whether you are a decision maker, an analyst, or a data engineer, we handle all the heavy lifting so you can focus on results.',
    cardData: [
        {
            image: {
                src: '/svg/ready.svg',
                alt: 'Ready-to-use pre-built AI models',
            },
            title: 'Ready-to-use pre built AI Models',
        },
        {
            image: {
                src: '/svg/easy-to-use.svg',
                alt: 'Seamless development and integration',
            },
            title: 'Seamless development and integration',
        },
        {
            image: {
                src: '/fast.svg',
                alt: 'Extremely short API response times',
            },
            title: 'Extremely short API response times',
        },
        {
            image: {
                src: '/svg/scalable.svg',
                alt: 'Scalable deployment for any business',
            },
            title: 'Scalable deployment for any business',
        },
        {
            image: {
                src: '/svg/edit.svg',
                alt: 'Rapidly and easily train custom models',
            },
            title: 'Rapidly and easily train custom models',
        },
        {
            image: {
                src: '/phone.svg',
                alt: 'Personalized pricing and effective support',
            },
            title: ' Personalized pricing and effective  support',
        },
    ],
}

export const HowItWorksContent = {
    heading: 'How it works',
    description:
        'You can help yourself to our growing library of available AI & ML models to get started instantly. Our team of experts are also available to work closely with you to provide consultancy on your specific needs and work with you to build custom models as needed.',
    cardData: [
        {
            image: {
                src: '/how-it-works/connect-data.svg',
                alt: 'Connect Data',
            },
            heading: 'Connect Data',
            description:
                'Connect your data using any of our various methods such as API integration or CSV file upload.',
        },
        {
            image: {
                src: '/how-it-works/select-model.svg',
                alt: 'Select AI Model',
            },
            heading: 'Select AI Model',
            description:
                'Select from a catalog of our pre-trained or custom trained models that fit your requirements.',
        },
        {
            image: {
                src: '/how-it-works/test.svg',
                alt: 'Test & Apply',
            },
            heading: 'Test & Apply',
            description:
                'Iterate on the model with your own dataset and get immediate access to an API endpoint when you are satisfied.',
        },
    ],
}
